import { useRouter } from 'next/router';
import { useMediaQuery } from 'usehooks-ts';
import { DividerHorizontal, CardImage } from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { SETTINGS } from '../../config/settings';
import { StyledSection } from '@components/layouts/Layouts';

const hubWeb = SETTINGS.public.urlHubWeb;

export const HomeAngeplusBenefitsSection = () => {
  const router = useRouter();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1024px)');

  const getBreakpoint = () => {
    if (isMobile) return 'mobile';
    if (isTablet) return 'tablet';
    return 'desktop';
  };

  const breakpoint = getBreakpoint();
  const src = `${router?.basePath}/assets/image/clube-angeplus-${breakpoint}.png`;

  return (
    <StyledSection>
      <DividerHorizontal />
      <LinkWrapper href={hubWeb}>
        <CardImage src={src} />
      </LinkWrapper>
    </StyledSection>
  );
};
